import Vue from 'vue';

const state = {
    globalLoading: undefined
}

const actions = {
    loading({commit}, vs) {
        const loading = vs.loading({
            type:'default',
            color: '#082258'
        });
        commit('DISPLAY_LOADING', loading)
        
    },

    closeLoading({commit}) {
        commit('HIDE_LOADING');
    },

    notify({commit}, payload) {
        Vue.prototype.$vs.notification({
            square: true,
            color: payload.error ? 'danger' :  'success',
            position:'top-right',
            title: payload.title || 'Thông báo',
            text: payload.text
          })
    }

}


const mutations = {
    DISPLAY_LOADING: (state, vsLoading) => {
        state.globalLoading = vsLoading;
    },

    HIDE_LOADING: (state) => {
        if(state.globalLoading) {
            state.globalLoading.close();
            state.globalLoading = undefined;
        }
    }
}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};